/* eslint-disable no-global-assign */
/* eslint-disable no-restricted-globals */
export const init = () => {
  /* SHOPPING TOOL - MODIFY PRODUCT IN CART */

  const fwk = CUBE.Analytics;
  const sep = AnalyticsConstants.separatorST;

  const stType = 'merchandising-cart';

  if (!$('body').hasClass('checkout-cart')) return;

  const event = CUBE.Analytics.utils.getEvent('confirmModifyProduct');
  if (event) {
    event.postAction(function($element) {
      const $product = $element.closest('.faux-table-wrapper');
      let model = fwk.utils.basketpage.getModel($product);
      if (!model) {
        let refId = $product.find('[model-id]').attr('model-id');
        model = fwk.utils.datalayer.getModel(refId);
        if (!model) {
          refId = $product.find('[product-id]').attr('product-id');
          model = fwk.utils.datalayer.getModel(refId);
        }
      }
      let price = model.price;
      let modelId = null;
      const confirmModel = $('#confirm_modification')
        .parents('.modify-product-wrapper')
        .find('.model-selection.slick-current');
      if (confirmModel.length > 0) {
        modelId = confirmModel.data('model-id');
        const confirmVariant = $product.find(
          '.size-wrap.selected select.size-selection-list option.selected'
        );
        if (confirmVariant.length > 0) {
          price = confirmVariant.data('price');
        }
      }
      let label = this.getLabel($element);
      const labelSplit = label.split('-');
      labelSplit[labelSplit.length - 1] = modelId;
      label = labelSplit.join('-');

      $product.attr('data-price', price);
      const quantity = parseFloat($product.find('.quantity-input').val());
      let position = model.position;
      if (!position) position = $product.index() + 1;

      fwk.shoppingtool.setTmp(
        stType,
        `modifyproduct${sep}position${sep}${position}`,
        label,
        parseFloat(price) * quantity
      );
      fwk.setCurrentProducts(position, {
        id: modelId,
        price: parseFloat(price),
        quantity,
        label,
        position,
      });
    });
  }
};



// WEBPACK FOOTER //
// ./src/analytics/shopping-tool/st-modify-product.js